import Head from "next/head";

import config from "config";

import NewProjectLayout from "modules/projects/elements/New-Project-Entitlement-Wrapper";
import CreateDriverAnalysis from "flows/driver-analysis-continous/views/create-project";

const CreateProject = () => {
  return (
    <>
      <Head>
        <title>
          {config.SITE_NAME} | Create New Continous Driver Analysis Project
        </title>
      </Head>
      <CreateDriverAnalysis />
    </>
  );
};

CreateProject.getLayout = (page) => <NewProjectLayout>{page}</NewProjectLayout>;

export default CreateProject;
